import { required, email, minLength } from 'vuelidate/lib/validators'
// import passwordComplexity from '@/utils/customValidators/passwordComplexity'

export default {
  tenant: {
    name: {
      required
    },
    genre: {
      required
    },
    phone: {
      required
    },
    country_register: {
      required
    },
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(6)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/active/tenant/resources/validations.js